/**
 * Normalisation des rôles utilisateur (string ou objet API).
 */

export const hasRole = (user, role) => {
  if (!user?.roles) return false;

  const normalizedRole = String(role).toLowerCase();

  return user.roles.some((userRole) => {
    if (typeof userRole === 'string') {
      return userRole.toLowerCase() === normalizedRole;
    }

    if (userRole && typeof userRole === 'object') {
      const candidate = userRole.name ?? userRole.role ?? userRole.value;
      return typeof candidate === 'string' && candidate.toLowerCase() === normalizedRole;
    }

    return false;
  });
};

export const isCreator = (user) => hasRole(user, 'creator') || hasRole(user, 'shop_owner');

export const isAdmin = (user) => hasRole(user, 'admin') || hasRole(user, 'super_admin');
